import { vehicleDocuments } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getVehicleDocumentsOption() {
    return new Promise((resolve, reject) => {
      axios
        .options(vehicleDocuments.base)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getVehicleDocumentsList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(vehicleDocuments.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getVehicleDocumentsObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${vehicleDocuments.base}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getVehicleDocumentsDetail(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${vehicleDocuments.base}${id}/view/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createVehicleDocumentsObject(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${vehicleDocuments.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateVehicleDocumentsObject(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${vehicleDocuments.base}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateVehicleDocumentsObject(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${vehicleDocuments.base}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  deleteVehicleDocumentsObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${vehicleDocuments.base}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  downloadVehicleDocumentsSheet() {
    return new Promise((resolve, reject) => {
      axios
        .get(`${vehicleDocuments.base}download_sheet/`, {
          responseType: "blob",
          headers: {
            Accept: "application/xlsx",
          },
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
